module.exports = __webpack_public_path__ + "img/a1.e9a0b56a.jpeg";